module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pre', {
    staticClass: "out__text",
    style: ({
      color: _vm.theme.accent
    })
  }, [_vm._v("  Slăvit să fie Domnul\n  căci El ne-a dăruit\n  Lumina şi-Ajutorul\n  s-ajungem la sfîrşit.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "out-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconPrev"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0082928","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/End.vue
// module id = 135
// module chunks = 1